import { ThunkDispatch } from 'redux-thunk';
import {
  addBannerMedia,
  getBannerAllList,
  removeBannerMedia,
} from '../../../features/bannerSlice';
import { isAPISuccess } from '../../../utils/Util';
import { toast } from 'react-toastify';
import {
  CLICK_ACTIONS,
  maxFilesInAdminSettings,
} from '../../../utils/Constant';

export const handleRemove = (
  removeMediaId: any,
  setShowLoader: (param: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>
) => {
  setShowLoader(true);
  dispatch(removeBannerMedia({ id: removeMediaId }))
    .then((fulfilled) => {
      setShowLoader(false);
      if (isAPISuccess(fulfilled.payload)) {
        toast.success(fulfilled.payload.responseInformation.responseMessage);
        dispatch(getBannerAllList({}));
      } else {
        toast.error(fulfilled.payload.responseInformation.responseMessage);
      }
    })
    .catch(() => {
      setShowLoader(false);
    });
};

export const uploadSelectedFiles = (
  files: File[],
  order: string | undefined,
  setShowLoader: (param: boolean) => void,
  setOrder: (param: string) => void,
  setFiles: (param: File[]) => void,
  dispatch: ThunkDispatch<any, any, any>
) => {
  if (!files || files.length === 0) {
    return;
  }
  if (!order) {
    toast.error('Order is required');
    return;
  }
  if (Number(order) < 1 || Number(order) > maxFilesInAdminSettings.banners) {
    toast.error(
      `Order should be between 1 and ${maxFilesInAdminSettings.banners}`
    );
    return;
  }
  const formData = new FormData();
  const allSelectedFiles = Object.values(files).flat();
  allSelectedFiles.forEach((file: File) => {
    formData.append('mediaFile', file);
  });
  formData.append('order', order);
  setShowLoader(true);
  dispatch(addBannerMedia(formData))
    .then((fulfilled) => {
      setShowLoader(false);
      if (isAPISuccess(fulfilled.payload)) {
        toast.success(fulfilled.payload.responseInformation.responseMessage);
        dispatch(getBannerAllList({}));
        setFiles([]);
        setOrder('');
      } else {
        toast.error(fulfilled.payload.responseInformation.responseMessage);
      }
    })
    .catch(() => {});
};

export const onRemove = (
  id: string,
  setShowAlertPopUp: (param: boolean) => void,
  setRemoveMediaId: (param: string) => void
) => {
  setShowAlertPopUp(true);
  setRemoveMediaId(id);
};
export const alertPopupToggle = (
  action: string,
  removeMediaId: string,
  setShowLoader: (param: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>,
  setShowAlertPopUp: (param: boolean) => void,
  setRemoveMediaId: (param: any) => void
) => {
  if (action === CLICK_ACTIONS.APPROVE) {
    handleRemove(removeMediaId, setShowLoader, dispatch);
  }
  setShowAlertPopUp(false);
  setRemoveMediaId(null);
};
